export default "__VITE_ASSET__DF1rPfq___"